<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-show="showMode==='pageSub'">
            <div class="head-container">
                <div class="left-head-container" @click="backList">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{ this.djTitle }}</div>
                <div class="left-head-container">
                    <el-form-item class="pull-right">
                        <el-input v-model="queryParams.title" placeholder="请输入名称搜索" class="input-with-select">
                            <template #append>
                                <el-button type="primary" @click="pageList(null)" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                            </template>
                        </el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="right-container">
                <div class="info-list-container">
                    <div class="dj-item" v-for="item in dataList" :key="item.dangjId">
                        <div class="dj-yuan"></div>
                        <div class="dj-item-l" @click="viewDangj(item)">{{item.title}}</div>
                        <div class="dj-item-r">{{ timestampDate(item.releaseTime) }}</div>
                    </div>
                    <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                </div>
                <div class="page-container" v-if="dataList&&dataList.length>0">
                    <pageTag :background="true"
                             :pageSizes="[10, 20, 30]"
                             v-show="total > 0"
                             :total="total"
                             v-model:page.sync="queryParams.pageNum"
                             v-model:limit.sync="queryParams.pageSize"
                             @pagination="pageList" />
                </div>
            </div>
        </div>
        <!--详情模式-->
        <div class="detail-mode" v-if="showMode==='detailSub'">
            <div class="dj-container">
                <div class="head-container">
                    <div class="left-head-container" @click="pageView">
                        <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </div>
                    <div class="right-head-container">{{ form.title }}</div>
                    <div class="left-head-container">
                    </div>
                </div>
                <div class="dj-time">发布时间：{{ timestampToTime(form.releaseTime) }}</div>
                <div class="dj-content" v-html="form.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import dangjInfo from "@/components/resourceCentre/dangjInfo.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {infoDangj, pageDangj} from "@/api/admin/dangj";

export default {
    name:'pageDangj',
    components:{pageTag, dataEmpty,dangjInfo},
    props:{
        infoMode:{
            type: String,
            default:null
        },
        title:{
            type: String,
            default:null
        },
        subTitle:{
            type: String,
            default:null
        },
        djType:{
            type: String,
            default:null
        },
    },
    watch:{
        infoMode(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        title(newValue,oldValue){
            this.djTitle = newValue;
        },
        subTitle(newValue,oldValue){
            this.djSubTitle = newValue;
            this.showMode = 'pageSub';
        },
        djType(newValue,oldValue){
            this.category = newValue;
            this.pageList();
        },
    },
    mounted() {
        this.pageList()
    },
    data() {
        return {
            showMode:'pageSub',
            djTitle:'',
            djSubTitle:'',
            timestampDate,
            category:'1',
            queryParams: {
                category:'',
                title:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            dangjId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        pageList(){
            this.queryParams.category = this.category
            pageDangj(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        viewDangj(item){
            this.dangjId = item.dangjId;
            this.getDangjInfo();
            this.showMode = "detailSub"
        },
        pageView(){
            this.showMode = "pageSub"
            // this.$emit('change-mode',this.showMode);
        },
        backList(){
            this.showMode = "page"
            this.$emit('change-mode',this.showMode);
        },
        getDangjInfo(){
            infoDangj({ dangjId: this.dangjId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },

    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.dj-top{
    width: 98% !important;
    height: 34px;
    line-height: 34px;
    color: #101010;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 2px solid #DDDDDD;
    margin: auto;
}
.right-container{
    width: 100%;
    height: auto;
}
.info-list-container{
    width: 100%;
    height: calc(100vh - 180px)!important;
    margin: auto;
    overflow-x: hidden;
}
.dj-item{
    width: 98% !important;
    height: 36px;
    margin: auto;
    display: flex;
}
.dj-item-l{
    width: calc(100% - 96px);
    height: 36px;
    margin: auto;
    color: #434343;
    line-height: 36px;
    font-size: 15px;
    padding-left: 3px;
    box-sizing: border-box;
    cursor: pointer;
}
.dj-item-l:hover{
    color: #0d55a4!important;
}
.dj-item-r{
    width: 90px;
    height: 36px;
    margin: auto;
    line-height: 36px;
    font-size: 15px;
    color: #999999;
}
.dj-yuan{
    width: 4px;
    height: 4px;
    border-radius: 1px;
    background-color: #999999;
    margin-top: 16px;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.detail-mode{
    width: 100%;
    height: auto;
}

.dj-container{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.dj-title{
    height: 45px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #DDD;
}
.dj-time{
    height: 40px;
    width: 98%;
    margin: auto;
    line-height: 40px;
    font-size: 15px;
    color: #666666;
}
.dj-content{
    width: 96%;
    margin: auto;
    overflow-x: hidden;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
</style>